export default __webpack_public_path__ + "static/B0035-e9e1fc4591ce910528abba75a9983977.png";